const LoginLayout = ({ children }: { children: React.ReactNode }) => {
  return <div className="login-page">{children}</div>;
};

export default LoginLayout;